import { useState, useEffect } from "react";

export const Footer = () => {
  const [cdmxTime, setCdmxTime] = useState('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setCdmxTime(now.toLocaleTimeString('en-US', { 
        timeZone: 'America/Mexico_City',
        hour: '2-digit', 
        minute: '2-digit',
        hour12: false 
      }));
    };
    
    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer id="site-footer" className="relative w-full bg-black">
      <div className="container mx-auto px-6 py-4">
        {/* Mobile: Single centered line */}
        <div className="md:hidden flex justify-center">
          <span className="font-sans text-[10px] tracking-[0.15em] text-white/30 uppercase pointer-events-auto">
            Los Angeles × CDMX {cdmxTime}
          </span>
        </div>

        {/* Desktop: Full layout */}
        <div className="hidden md:flex items-center justify-between">
          <span className="font-sans text-[10px] tracking-[0.2em] text-white/35 uppercase">
            Los Angeles × CDMX {cdmxTime}
          </span>

          <a
            href="mailto:alabamaaistudios@gmail.com"
            className="font-sans text-[10px] tracking-[0.2em] text-white/35 hover:text-white/60 transition-colors duration-300 pointer-events-auto py-1 min-h-[24px] inline-flex items-center"
          >
            alabamaaistudios@gmail.com
          </a>

          <div className="flex items-center gap-4 pointer-events-auto">
            <a
              href="https://instagram.com/alabama_ai"
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans text-[10px] tracking-[0.2em] text-white/35 hover:text-white/60 transition-colors duration-300 uppercase py-1 min-h-[24px] inline-flex items-center"
            >
              Instagram
            </a>
            <a
              href="https://wa.me/12149145106"
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans text-[10px] tracking-[0.2em] text-white/35 hover:text-white/60 transition-colors duration-300 uppercase py-1 min-h-[24px] inline-flex items-center"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};